import { FC } from 'react';
import { SxProps, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PackageOverview } from '@modules/Tributes/Views/CreateTribute/PackageOverview';
import HeartPulse from '@modules/Tributes/components/HeartPulse';


type Props = {
  cardsOnly: boolean
}

export const Hero: FC<Props> = ({ cardsOnly }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const petCards = getPetCards(isMobile);

  return (
    <Stack gap={1}>
      <Stack direction={{ xs: 'column-reverse', sm: 'column' }} gap={1}>
        <Stack alignItems="center" gap={1}>
          <HeartPulse color="primary.main" size={24} />
          <Typography variant="h3" textTransform="uppercase" fontWeight="bold">
            Create A LGCY
          </Typography>
          <Typography variant="body1" fontSize="1.125rem" color="textSecondary" textAlign="center">
            Your Journey of Love begins here. Follow the simple steps to create your LGCY pet.
          </Typography>
        </Stack>
        {!cardsOnly && (
          <Box sx={{ display: { sm: 'none' } }} width="100%">
            <PackageOverview />
          </Box>
        )}
      </Stack>
      <Box sx={getCardsContainerSXProps(cardsOnly)} width="100%">
        <Grid sx={{ overflowX: 'auto' }} container justifyContent="space-between" wrap="nowrap" spacing={2} maxWidth="100%" overflow="hidden">
          {petCards.map((card) => (
            <img key={card} width="153" height="243" src={`/pet-cards/${card}`} alt={card} />
          ))}
        </Grid>
      </Box>
    </Stack>
  );
};

const getCardsContainerSXProps = (cardsOnly: boolean): SxProps => {
  return cardsOnly ? {} : {
    display: { xs: 'none', sm: 'block' },
  };
};

const allPetCards = ['luna.png', 'trixie.png', 'roscoe.png', 'null.png', 'sparkle.png', 'sampson.png'];

const getPetCards = (isMobile: boolean) => {
  return isMobile ? allPetCards.slice(0, 3) : allPetCards;
};
